module.exports = __webpack_public_path__ + "img/file-minus.4e4532f8.svg";